/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PermissionCode {
    MANAGE_EMPLOYEES = 'manage_employees',
    VIEW_COMPOSITE_EMPLOYEES = 'view_composite_employees',
    VIEW_SURVEY_PARTICIPATIONS = 'view_survey_participations',
    VIEW_USERS = 'view_users',
    MANAGE_USERS = 'manage_users',
    MANAGE_ROLES = 'manage_roles',
    MANAGE_PLANS = 'manage_plans',
    MANAGE_PAYMARKETS = 'manage_paymarkets',
    MANAGE_CURRENCIES = 'manage_currencies',
    MANAGE_AGING = 'manage_aging',
    MANAGE_TAGS = 'manage_tags',
    MANAGE_SURVEYS = 'manage_surveys',
    LOAD_FILES = 'load_files',
    MANAGE_LEVEL_MAPPINGS = 'manage_level_mappings',
    MANAGE_DATA_CUT_PAYMARKET_MAPPINGS = 'manage_data_cut_paymarket_mappings',
    MANAGE_COMPANY_JOBS = 'manage_company_jobs',
    MANAGE_PRICING_POLICIES = 'manage_pricing_policies',
    MASS_APPLY_PRICING_POLICIES = 'mass_apply_pricing_policies',
    MASS_ENHANCED_APPLY_PRICING_POLICIES = 'mass_enhanced_apply_pricing_policies',
    MANAGE_TARGET_PERCENTILES = 'manage_target_percentiles',
    MANAGE_CUSTOM_PERCENTILES = 'manage_custom_percentiles',
    MANAGE_DATA_MODELS = 'manage_data_models',
    VIEW_ANALYZE_DASHBOARDS = 'view_analyze_dashboards',
    MANAGE_REPORTS = 'manage_reports',
    MARKET_PRICING = 'market_pricing',
    MANAGE_API_SETTINGS = 'manage_api_settings',
    MANAGE_JOB_MAPPING_MODE = 'manage_job_mapping_mode',
    MANAGE_DATA_ACCESS_GROUPS = 'manage_data_access_groups',
    MANAGE_DATA_LOADER = 'manage_data_loader',
    UPLOAD_DATA_FILES = 'upload_data_files',
    VIEW_DATA_HISTORY = 'view_data_history',
    CANCEL_DATA_LOADS = 'cancel_data_loads',
    EDIT_DATA_TRANSFORMATIONS = 'edit_data_transformations',
    DOWNLOAD_DATA_ERRORS = 'download_data_errors',
    BYPASS_SCHEMA_VALIDATION = 'bypass_schema_validation',
    REQUEST_DATA_SUPPORT = 'request_data_support',
    MANAGE_IDP = 'manage_idp',
    REPLACE_CUT_MAPPINGS = 'replace_cut_mappings',
    MANAGE_SECURITY_EVENT_API = 'manage_security_event_api',
    REPLACE_UPDATE_SURVEY = 'replace_update_survey',
    MANAGE_RANGE_ASSIGNMENTS = 'manage_range_assignments',
    MANAGE_TENANCY_SWITCHER = 'manage_tenancy_switcher',
    MANAGE_AI_FEATURES = 'manage_ai_features',
}
